import { Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ServiceRangeBadges } from "./ServiceRangeBadges";

type ProviderHeaderProps = {
  name: string;
  serviceRanges: string[];
  badges?: string[];
  providerId?: string;
};

export const ProviderHeader = ({ name, serviceRanges, badges, providerId }: ProviderHeaderProps) => {
  const navigate = useNavigate();

  const handleNameClick = () => {
    if (providerId) {
      navigate(`/providers/${providerId}`);
    }
  };

  return (
    <div className="flex flex-col gap-3 min-w-0">
      {/* Header with Name and Service Ranges */}
      <div className="flex flex-wrap items-center gap-3">
        <h5
          className={`text-2xl lg:text-3xl font-recoleta font-bold text-[#111827] break-words ${providerId ? 'cursor-pointer hover:text-[#026857] transition-colors' : ''}`}
          onClick={handleNameClick}
          role={providerId ? "button" : undefined}
          tabIndex={providerId ? 0 : undefined}
          onKeyDown={providerId ? (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              if (e.key === ' ') {
                e.preventDefault();
              }
              handleNameClick();
            }
          } : undefined}
        >
          {name}
        </h5>
        <ServiceRangeBadges serviceRanges={serviceRanges} />
      </div>
      
      {/* Badges/Highlights Section */}
      {badges && badges.length > 0 && (
        <div className="flex items-start gap-3 pt-1.5">
          <div className="relative group flex items-start justify-start h-10 w-10 shrink-0">
            <Sparkles className="h-8 w-8 shrink-0 text-[#026857]" aria-hidden="true" />
            <div className="pointer-events-none absolute left-1/2 top-full mt-2 -translate-x-1/2 translate-y-1 opacity-0 transition-all duration-200 group-hover:translate-y-0 z-10 group-hover:opacity-100">
              <div className="rounded-xl border border-[#E5E7EB] bg-white px-3 py-1.5 shadow-xl whitespace-nowrap text-xs font-termina capitalize text-[#111827]">
                Highlights
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2 flex-wrap flex-1">
            {badges.map((badge: string, index: number) => (
              <span
                key={index}
                className="inline-flex items-center rounded-full border border-[#111827] bg-white px-4 py-1.5 text-xs font-termina text-[#111827]"
              >
                {badge}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

